import React, {Component} from 'react';
import SearchForm from '../SearchForm';
import Packages from '../ServicePackages';
import Coupons from '../Coupons';
import axios from "axios";
import {unauthApiUrl} from "../../../Shared/api";

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vat: '',
            supplyCode: '',
            packages: [],
            coupons: [],
            supplyType: null,
            error: false,
            yolo: true,
            isPrintClicked: false,
            isSearchClicked: false
        }
    }

    inputHandler = (newState) => {
        this.setState(newState);
    };

    toggleCheck = (key) => {
        const packages = this.state.packages.map(
            pack => pack.code === key
                ? Object.assign({}, pack, {checked: !pack.checked})
                : pack
        );
        this.setState({packages});
    };

    toggleFloorPlan = () => {
        const {noFloorPlan} = this.state;
        const packages = this.state.packages.map(
            pack => pack.code === "003"
                ? Object.assign({}, pack, {
                    floorPlan: !(!!pack["floorPlan"]),
                    noFloorPlan: noFloorPlan ? false : noFloorPlan
                })
                : pack
        );
        this.setState({packages});
    };

    toggleNoFloorPlan = () => {
        const {floorPlan} = this.state;
        const packages = this.state.packages.map(
            pack => pack.code === "003"
                ? Object.assign({}, pack,
                    {
                        noFloorPlan: !(!!pack["noFloorPlan"]),
                        floorPlan: floorPlan ? false : floorPlan
                    })
                : pack
        );
        this.setState({packages});
    };

    getPackages = () => {
        const { vat, supplyCode } = this.state;
        this.setState({ isSearchClicked: true });

        axios.post(
            unauthApiUrl('packages/get'), {
                vat,
                supplyCode
            })
            .then((response) => {
                this.setState({ isSearchClicked: false });
                const {supplyType, packages} = response.data;
                this.setState(packages.length
                    ? {
                        packages: packages.map((pack) => ({
                            code: pack.code,
                            name: pack.name,
                            checked: false,
                            error: null
                        })),
                        supplyType,
                        error: null
                    }
                    : {packages: [], coupons: [], error: "Δεν βρέθηκαν διαθέσιμα πακέτα."});
            })
            .catch((error) => {
                this.setState({ isSearchClicked: false });
                if (error.response) {
                    const errorId = error.response.data.ErrorId || error.response.data.errorId;
                    const errors = error.response.data.Errors || error.response.data.errors || [];
                    const message = error.response.data.Message || error.response.data.message;
                    const err = errors.reduce((acc, error) => acc.concat(error.errors), []).join('\n');
                    const errorMessage = `${message || ''}\n${err}`;
                    this.setState({error: errorMessage, packages: [], coupons: []});
                } else if (error.message) {
                    this.setState({error: error.message, packages: [], coupons: []});
                } else {
                    this.setState({error: error, packages: [], coupons: []});
                }
            });
    };

    submitPackages = () => {
        const checkedPacks = this.state.packages
            .filter(pack => pack.checked);
        const {vat, supplyCode} = this.state;
        this.setState({isPrintClicked: true});

        axios.post(
            unauthApiUrl('packages/print'), {
                vat,
                supplyCode,
                packages: checkedPacks
            })
            .then((response) => {
                this.setState({isPrintClicked: false});
                const coupons = response.data || [];
                const showCoupons = coupons.length > 0;
                if (showCoupons) {
                    this.setState({coupons, error: null})
                } else {
                    this.setState({error: 'Δεν βρέθηκαν κουπόνια.'})
                }
            })
            .catch((error) => {
                this.setState({isPrintClicked: false});
                if (error.response) {
                    const errorId = error.response.data.ErrorId || error.response.data.errorId;
                    const errors = error.response.data.Errors || error.response.data.errors || [];
                    const message = error.response.data.Message || error.response.data.message;
                    const err = errors.reduce((acc, error) => acc.concat(error.errors), []).join('</br>');
                    const errorMessage = `${message || ''}</br>${err}`;
                    this.setState({error: errorMessage, packages: [], coupons: []});
                } else if (error.message) {
                    this.setState({error: error.message, packages: [], coupons: []});
                } else {
                    this.setState({error: error, packages: [], coupons: []});
                }
            });
    };


    render() {
        const {vat, supplyCode, packages, error, coupons, isPrintClicked, isSearchClicked} = this.state;
        const showCoupons = coupons.length > 0;
        return (
            <React.Fragment>
                {
                    showCoupons === false
                        ? (
                            <div className={"packages-container"}>
                                <div className={"package-container"}>
                                    <div className={"package"}>
                                        <div className={"package-form-container"}>
                                            <SearchForm
                                                vat={vat}
                                                supplyCode={supplyCode}
                                                onChange={this.inputHandler}
                                                onSubmit={this.getPackages}
                                                isSearchClicked={isSearchClicked}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Packages
                                    packages={packages}
                                    onCheck={this.toggleCheck}
                                    floorPlanClicked={this.toggleFloorPlan}
                                    nofloorPlanClicked={this.toggleNoFloorPlan}
                                    onSubmitPackages={this.submitPackages}
                                    isPrintClicked={isPrintClicked}
                                />
                                {error
                                    ? (<div className="packages-error" role="alert">
                                        {error}
                                    </div>)
                                    : null}
                            </div>
                        )
                        : (<Coupons coupons={coupons}/>)
                }
            </React.Fragment>
        );
    }
}